import moment from 'moment';

import { AgentResourceModel, AgentThreadCreationRequest, DataPayload, DataPayloadType } from '../../../../../gamma-api';
import { PUBLIC_URL } from '../../../../utils/configUtil';
import { StagedAttachment } from '../../../../components/AgentTestingChat/types';

export const buildThreadCreationRequest = (agentId: string): AgentThreadCreationRequest => ({
  agent_id: agentId,
  name: `Testing thread ${moment().toISOString()}`,
});

export const mapResourceToDataPayload = (resource: AgentResourceModel): DataPayload => ({
  type: DataPayloadType.Resource,
  data: {
    name: resource.name,
    settings: resource.settings,
  },
});

export const getAttachmentPublicUrl = (attachment: StagedAttachment): string =>
  `${PUBLIC_URL}${attachment.model?.urls.public}`;

export const mapAttachmentsToDataPayloads = (attachments: StagedAttachment[]): DataPayload[] =>
  attachments
    .filter((attachment) => attachment.model)
    .map((attachment) => {
      return {
        type: DataPayloadType.File,
        data: {
          mime_type: attachment.file.type,
          file_name: attachment.file.name,
          url: getAttachmentPublicUrl(attachment),
        },
      };
    });
